import { useState } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Typography,
} from "@mui/material";

export default function RecoveryDialog({ open, loading, onClose, onRestore, onForceDelete }) {
  const [id, setId] = useState("");

  return (
    <Dialog open={open} onClose={loading ? undefined : onClose} fullWidth maxWidth="sm">
      <DialogTitle>Deleted firewall recovery</DialogTitle>
      <DialogContent dividers>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
          The current API does not provide a deleted-firewall listing. Enter a deleted firewall UUID to restore it or permanently remove it.
        </Typography>
        <TextField fullWidth label="Firewall UUID" value={id} onChange={(event) => setId(event.target.value)} />
      </DialogContent>
      <DialogActions>
        <Button onClick={onClose} disabled={loading}>Cancel</Button>
        <Button color="error" disabled={loading || !id.trim()} onClick={() => onForceDelete(id.trim())}>Force delete</Button>
        <Button variant="contained" disabled={loading || !id.trim()} onClick={() => onRestore(id.trim())}>Restore</Button>
      </DialogActions>
    </Dialog>
  );
}
